import { defineMessages } from 'react-intl'

export const loginMessages = defineMessages({
  helpButton: {
    id: 'login.helpButton',
    description: 'Text for help button in header',
    defaultMessage: 'Need help',
  },
  getAccount: {
    id: 'login.getAccount',
    description: 'Information about where the user can get an account',
    defaultMessage:
      'Need an account? You must already have a Savant System installed, and have the Savant app.',
  },
  findDealer: {
    id: 'login.findDealer',
    description: 'Text on a button that leads to "Find a Dealer" ',
    defaultMessage: 'Find a Dealer',
  },
  loginHeading: {
    id: 'login.loginHeading',
    description: 'Main heading of "Log In" page',
    defaultMessage: 'Sign In',
  },
  loginButton: {
    id: 'login.loginButton',
    description: 'Text on a button to submit "login" form ',
    defaultMessage: 'Sign In',
  },
  logoutButton: {
    id: 'login.logoutButton',
    description: 'Text on a button to sign out of "login" form ',
    defaultMessage: 'Sign Out',
  },
  forgotPassword: {
    id: 'login.ForgotPassword',
    description: 'Text on a button that will open "Forgot password" form',
    defaultMessage: 'Forgot password?',
  },
  emailPlaceholder: {
    id: 'login.emailPlaceholder',
    description: 'Text to be used in "Email" input',
    defaultMessage: 'Email',
  },
  passwordPlaceholder: {
    id: 'login.passwordPlaceholder',
    description: 'Text to be used in "Password" input',
    defaultMessage: 'Password',
  },
  needSavantSystem: {
    id: 'login.needSavant',
    description: 'Text asks if user need to install Savant system',
    defaultMessage: 'Need a Savant system installed?',
  },
  manageSavantHomes: {
    id: 'login.manageHomes',
    description: 'Log in page subtitle',
    defaultMessage: 'Please use your Savant Account credentials to sign in.',
  },
  termsAndPolicy: {
    id: 'login.termsAndPolicy',
    description: 'Terms and Policy text',
    defaultMessage: 'By signing in, I agree to the {terms} and {privacy}.',
  },
  termsOfService: {
    id: 'login.termsOfService',
    description: 'Terms of Service text',
    defaultMessage: 'Terms of Service',
  },
  privacyPolicy: {
    id: 'login.privacyPolicy',
    description: 'Privacy Policy text',
    defaultMessage: 'Privacy Policy',
  },
  wrongCredentials: {
    id: 'login.validation.wrongCredentials',
    description: 'Error text when users not found or credentials are wrong',
    defaultMessage:
      'This email / password combination is incorrect. If you have trouble accessing your account, select “Forgot password?”',
  },
  cancelButton: {
    id: 'login.cancelButton',
    description: 'Cancel forgot password button',
    defaultMessage: 'Cancel',
  },
  sendEmailButton: {
    id: 'login.sendEmail',
    description: 'Submit forgot password button',
    defaultMessage: 'Send Email',
  },
  forgotPasswordHeading: {
    id: 'login.forgotPasswordHeading',
    description: 'Main heading of "Forgot Password" page',
    defaultMessage: 'Forgot password',
  },
  forgotPasswordDescription: {
    id: 'login.forgotPasswordDescription',
    description: 'Secondary heading of "Forgot Password" page',
    defaultMessage:
      'Enter your email and we’ll send you a link to reset your password',
  },
  forgotPasswordSubmittedHeading: {
    id: 'login.forgotPasswordSubmittedHeading',
    description: 'Main heading of "Forgot Password Submitted" page',
    defaultMessage: 'Password email Sent',
  },
  forgotPasswordSubmittedDescription: {
    id: 'login.forgotPasswordSubmittedDescription',
    description: 'Secondary heading of "Forgot Password Submitted" page',
    defaultMessage:
      'Check your email for instructions on how to set a new password',
  },
  goToSignInButton: {
    id: 'login.goToSignInButton',
    description: 'Return to sign in button on password forgotten page',
    defaultMessage: 'Go To Sign In',
  },
  verifyButton: {
    id: 'login.verifyButton',
    description: 'Submit button on 2FA page',
    defaultMessage: 'Verify',
  },
  twoFaHeading: {
    id: 'login.twoFaHeading',
    description: 'Main heading of "2FA" page',
    defaultMessage: 'Verification Code',
  },
  twoFaDescription: {
    id: 'login.twoFaDescription',
    description: 'Secondary heading of "2FA" page',
    defaultMessage:
      'To help keep your account secure, we’ve sent a verification code to your email {email}.{br}{br}Please enter the 6 digit code below. Your code expires in 30 minutes.',
  },
  cantFindEmail: {
    id: 'login.cantFindEmail',
    description: 'Footer message on "2FA" page',
    defaultMessage: 'Can’t find our email?',
  },
  resendVerification: {
    id: 'login.resendVerification',
    description: 'Resend email button on "2FA" page',
    defaultMessage: 'Resend Verification',
  },
  resendVerificationSuccessHeader: {
    id: 'login.resendVerificationSuccessHeader',
    description: 'Header of "verification resent" page',
    defaultMessage: 'Verification Resent Successfully',
  },
  proceedButton: {
    id: 'login.proceedButton',
    description: 'Proceed button text',
    defaultMessage: 'Proceed',
  },
  resendFailedHeader: {
    id: 'login.resentFailedHeader',
    description: 'Header of "resent failed" page',
    defaultMessage: 'Resending Verification Failed',
  },
  resendFailedError: {
    id: 'login.resentFailedError',
    description: 'Error message of "resent failed" page',
    defaultMessage:
      'We encountered an error processing your verification code resend request.',
  },
  tryAgainButton: {
    id: 'login.tryAgainButton',
    description: 'Try resending verification again of "resent failed" page',
    defaultMessage: 'Try Again',
  },
  verificationFailedHeader: {
    id: 'login.verificationFailedHeader',
    description: 'Header of "verification failed" page',
    defaultMessage: 'Verification Failed',
  },
  verificationFailedError: {
    id: 'login.verificationFailedError',
    description: 'Error message of "verification failed" page',
    defaultMessage:
      'We encountered an error processing your verification code.',
  },
  resendCodeButton: {
    id: 'login.resendCodeButton',
    description: 'Resend code button of "verification failed" page',
    defaultMessage: 'Resend Code',
  },
  loginError: {
    id: 'login.loginError',
    description: 'Error message on failed login attempt',
    defaultMessage: 'The username or password entered is incorrect.',
  },
  errorHeader: {
    id: 'login.errorHeader',
    description: 'Header of the failed login attempt screen',
    defaultMessage: 'Sign In Error',
  },
  domainErrorHeader: {
    id: 'login.domainErrorHeader',
    description: 'Header of no domains for user error',
    defaultMessage: 'Domain Error',
  },
  domainError: {
    id: 'login.domainError',
    description: 'Error message of no domain',
    defaultMessage:
      'Your Savant Account is not yet associated with a Dealer Organization in Savant Central Management. For Access, please contact your Dealer Organization admin.',
  },
})
